/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class PropertyCategory.
* @enum {}
* @readonly
*/
export default class PropertyCategory {
    
        /**
         * value: "区分マンション"
         * @const
         */
        "区分マンション" = "区分マンション";

    
        /**
         * value: "一棟物件"
         * @const
         */
        "一棟物件" = "一棟物件";

    
        /**
         * value: "戸建"
         * @const
         */
        "戸建" = "戸建";

    

    /**
    * Returns a <code>PropertyCategory</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/PropertyCategory} The enum <code>PropertyCategory</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

